<template>
  <div>
    <w-note-info-fold v-if="$store.getters['right/getRole'] !== 'USER'" title="系统自动释放分析结果/报告说明">
      <template slot="noteInfo">
        <div >
          <div style="display:flex;gap: 20px;height: 130px;padding: 20px 30px 10px 30px;font-size: 14px">
            <div class="circle">
              <div> 1、交付系统中<span class="highlight-font">报告审批通过</span>（有报告）；</div>
              <div> 2、对纯分析/无原始数据项目<span style="color: #9ea2a6">（<span style="font-size: 13px">注1</span>）</span>，需要项目管理系统<span
                  class="highlight-font">分析结果/原始数据审批通过</span>；
              </div>
              <div> 3、在商务系统中<span class="highlight-font">对应合同号存在</span><span
                  style="color: #9ea2a6">（<span style="font-size: 13px">注2</span>）</span>且<span class="highlight-font">全款到账/签署完成</span>。
              </div>
            </div>
            <div
                style="display: flex;flex-direction: column;justify-content: space-between;min-width: 100px;margin:6px 0px;">
              <div style="display: flex;flex-direction: column;align-items: center;margin: auto">
                <span style="color: rgb(4,136,4)">满足条件</span>
                <i v-html="arrowheadIcon" style="color: silver"></i>
              </div>
            </div>
            <div style="display: flex;flex-direction: column;justify-content: space-between;">
              <div style="color: rgb(4,136,4);margin: auto">系统自动动释放分析结果/报告，发送邮件至客户</div>
            </div>
          </div>
          <div style="padding: 0px 30px 20px 30px;font-size:14px;color: #909399;">
            <span style="font-size: 13px">注1</span>：参照项目管理系统类型详情：如 蛋白代谢组测序/类固醇激素 为无原始数据项目；<br>
            <span style="font-size: 13px">注2</span>：商务系统有登记类型为 宏基因组 上传报告为 转录组 则不能释放报告；
          </div>
        </div>


      </template>
    </w-note-info-fold>
  </div>


</template>

<script>
import {arrowheadIcon} from "@/utils/iconUtils";

export default {
  name: "ReportReleaseNote",
  data() {
    return {
      arrowheadIcon: arrowheadIcon
    }
  }
}
</script>


<style scoped>
.highlight-font {
  color: rgba(229, 39, 39, 0.97);
}

.circle {
  min-width: 500px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 25px;
  background-color: #eef5fe;
  padding: 0 15px;
  gap: 8px;
}
</style>
